import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-custom-switcher',
    templateUrl: './custom-switcher.component.html',
    styleUrls: ['./custom-switcher.component.css'],
    standalone: false
})
export class CustomSwitcherComponent {

  @Input() tooltip: string;
  @Input() status: boolean | 'ACTIVE' | 'INACTIVE' = false;
  @Output() statusChange = new EventEmitter<'ACTIVE' | 'INACTIVE' | 'enable' | 'disable' | true | false>();

  get isActive(): boolean {
    return this.status === true || this.status === 'ACTIVE';
  }

  onToggle(event: any): void {
    const checked = event.checked;
    let valueToEmit: 'ACTIVE' | 'INACTIVE' | 'enable' | 'disable';

    if (typeof this.status === 'string') {
      valueToEmit = checked ? 'ACTIVE' : 'INACTIVE';
    } else {
      valueToEmit = checked ? 'enable' : 'disable';
    }

    this.statusChange.emit(valueToEmit);
  }
}
